import { Controller } from "@hotwired/stimulus";

const FOCUSABLE =
  "a[href], button:not(:disabled), input:not(:disabled):not([type=hidden]), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex='-1'])";

export default class extends Controller {
  next() {
    const stops = [...document.querySelectorAll(FOCUSABLE)].filter(
      (element) => element.checkVisibility() && !this.#skippedRadio(element),
    );
    stops[stops.indexOf(this.element) + 1]?.focus();
  }

  #skippedRadio(element) {
    if (element.type !== "radio" || element.checked) return false;

    return document.querySelector(
      `input[type=radio][name="${CSS.escape(element.name)}"]:checked`,
    );
  }
}
